import { ChangeDetectionStrategy, Component } from '@angular/core';

import { RevealDirective } from '@ledgerly/common/browser';

import { StoreBadgesComponent } from '@ledgerly/shared/layout';

@Component({
  selector: 'app-pricing',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RevealDirective, StoreBadgesComponent],
  templateUrl: './pricing.component.html',
})
export class PricingComponent {
  /**
   * Yearly, lifetime, monthly: the paywall's own order.
   *
   * Terms are the shipped strings (`paywallTermsYearly`,
   * `paywallTermsLifetime`, `paywallTermsMonthly`, `planLifetimeNote`).
   *
   * There is deliberately no `price` field on this type. Adding one would
   * invite a hardcoded figure, and the figure is not ours to state. The store
   * returns it, per region, at runtime. If a price ever does belong on this
   * page it needs a per-country story first, because one build serves five
   * languages and many more countries.
   */
  protected readonly plans = [
    {
      name: $localize`:@@planYearly:Yearly`,
      badge: $localize`:@@planBadgeCommon:Most people`,
      terms: $localize`:@@pricingTermsYearly:Billed yearly. Cancel anytime.`,
      note: $localize`:@@pricingNoteYearly:The store shows the yearly price and what that works out to each month.`,
      emphasis: true,
    },
    {
      name: $localize`:@@planLifetime:Lifetime`,
      badge: '',
      terms: $localize`:@@pricingTermsLifetime:One payment. Nothing renews, nothing to cancel.`,
      note: $localize`:@@pricingNoteLifetime:Pay once. Nothing renews.`,
      emphasis: false,
    },
    {
      name: $localize`:@@planMonthly:Monthly`,
      badge: '',
      terms: $localize`:@@pricingTermsMonthly:Billed monthly. Cancel anytime.`,
      note: $localize`:@@pricingNoteMonthly:For when you would rather not commit to a year.`,
      emphasis: false,
    },
  ];
}
